type AnyRecord = Record<string, any>;

/**
 * "Where we are" — the agent's own note on the deal snapshot, or the phase's
 * default status line. Shared by every portal; nothing here is client-only,
 * so a lender or attorney reads the identical note a client does.
 */
interface PortalCurrentChapterProps {
  deal: AnyRecord;
  agent?: AnyRecord | null;
  testId?: string;
}

export default function PortalCurrentChapter({ deal, agent, testId = "portal-current-chapter" }: PortalCurrentChapterProps) {
  const chapter = (deal.snapshot && deal.snapshot.status_note) || null;
  const fallback = (deal.snapshot && deal.snapshot.status_note_default) || "";
  // No note and no phase default means there is genuinely nothing to say. An
  // empty tinted panel headed "From your agent" reads as a message that failed
  // to load, so render nothing instead.
  if (!chapter && !fallback) return null;

  return (
    <div
      className="border border-dash-border rounded-2xl p-6 bg-dash-hover flex flex-col gap-2 animate-in fade-in slide-in-from-bottom-4 duration-500 delay-100 ease-out"
      data-testid={testId}
    >
      <div className="text-[10px] font-bold uppercase tracking-[1.5px] text-dash-muted">
        {agent?.name ? `📢 From ${agent.name}` : "📢 Where we are"}
      </div>
      <p className="text-base font-medium leading-[1.5] text-dash-greenDeep">
        {chapter || fallback}
      </p>
    </div>
  );
}
